import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('TransportationScheduleService', TransportationScheduleService);

  TransportationScheduleService.$inject = ['$translate', '$filter', 'UtilService'];

  function TransportationScheduleService($translate, $filter, UtilService) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'transportations';

    var service = {
      changeTransportationScheduleStatus: changeTransportationScheduleStatus,
      deleteTransportationSchedule: deleteTransportationSchedule,
    };

    return service;

    ////////////////

    function changeTransportationScheduleStatus(transportationId, schedule) {
      var url = apiUrl + '/' + transportationId + '/transportation_schedules/' + schedule.id;

      var params = {
        successMsg: 'SCHEDULE_MODIFIED',
      };

      utils.changeItemStatus(url, schedule, params);
    }

    function deleteTransportationSchedule(transportationId, schedule, successCallback, index) {
      var url = apiUrl + '/' + transportationId + '/transportation_schedules/' + schedule.id;

      var params = {
        title: 'SURE_TO_DELETE_SCHEDULE',
        reason: 'DELETE_ITEM_REASON',
        confirmButtonLabel: 'DELETE_SCHEDULE',
        successMsg: 'DELETED_SCHEDULE',
      };

      utils.deleteItem(url, successCallback, params, index);
    }
  }
})();
